<template>
<div>
  <div class="background"></div>

  <div class="LogoHeader py-20">
    <Logo />
  </div>
  
  <div class="container barlow p-30">
    <h2 class="gretaros mb-15">Welcome</h2>
    <p class="mb-30 reg-text barlow">Register below to enjoy our complimentary Wi-Fi, available throughout all corners at EAST. Gain access using just one of the following methods.
    <h3 class="gretaros">Room Guest</h3>
    <div class="mb-20"><input class="barlow" v-model="form.last_name" type="text" placeholder="Last Name" /></div>
    <div class="mb-20"><input class="barlow" v-model="form.room_number" type="text" placeholder="Room Number" /></div>
    <h3 class="gretaros">Other Guest</h3>
    <div class="mb-20"><input class="barlow" v-model="form.access_code" type="text" placeholder="Access Code" /></div>
    <div class="mb-10">
      <TermsOfService variant="checkbox" consent_text="I consent to the" consent_action_text="Privacy Policy" @onChangeCheckboxConsent="handleOnChangeCheckboxConsent"></TermsOfService>
    </div>
    <div class="pt-20">
      <button class="gretaros mb-20" :disabled="disabled || !show_continue" @click="handleClickConnect()">Connect</button>
    </div>
  </div>

</div>
</template>
  
<script>
  import Logo from '@/components/custom/eastMiami/Logo'
  import TermsOfService from '@/utilities/TermsOfService'
  
  export default {
    name: 'custom_template',
    props: [ 'template', 'portal', 'connection_data' ],
    components: { Logo, TermsOfService },
    computed: {
      show_continue:function(){
        return this.consent && ((this.form.last_name && this.form.room_number) || !!this.form.access_code);
      },
    },
    data(){
      return{
        disabled: true,
        consent: false,
        form: {
          access_code: null,
          room_number: null,
          last_name: null,
        },
      }
    },
    watch: {
      'form': {
        deep: true,
        handler(){ this.disabled = false }
      }
    },
    created(){
      document.documentElement.classList.add('eastMiami');
    },
    methods: {
      handleOnChangeCheckboxConsent(value){
        this.consent = value;
      },
      setRegistrationData(){
        if(this.form.last_name && this.form.room_number){
          const registration_method = this.portal.registration_methods.find(registration_method => registration_method.registration_method_id === 2);
          const rateplan_id = registration_method.rate_plans[0].rateplan_id;
          return {
            registration_method_id: registration_method.registration_method_id,
            rateplan_id: rateplan_id,
            last_name: this.form.last_name,
            room_number: this.form.room_number,
          }
        } else if(this.form.access_code) {
          return {
            registration_method_id: 4,
            access_code: this.form.access_code,
          }
        }
      },
      handleClickConnect: function(){
        this.disabled = true;
        this.$emit('emitRegistrationMethodData', this.setRegistrationData() );
      },
    }
  }
  </script>
  <style>
  @font-face { font-family: 'Barlow'; font-weight: normal; src: url('https://sky-production.s3.amazonaws.com/brandportalimages/font-barlow-condensed-regular.ttf'); }
  @font-face { font-family: 'Gretaros'; font-weight: normal; src: url('https://sky-production.s3.amazonaws.com/brandportalimages/font-gretaros-regular.ttf'); }
  .eastMiami .background { opacity: 0.2; z-index: -1; background-image: url('https://sky-production.s3.amazonaws.com/brandportalimages/east-miami-background.jpg'); position: fixed; top: 0; left: 0; right: 0; bottom: 0; width: 100%; background-size: cover; background-position: center; }
  .eastMiami h2 {
    font-size: 18px;
    font-weight: bold;
  }

  .eastMiami h3 {
    font-size: 14px;
    font-weight: bold;
  }
  .eastMiami .reg-text{
    font-size: 12px;
  }
  .eastMiami .LogoHeader { background: #fff; width: 100%; display: flex; justify-content: center; }
  .eastMiami .gretaros { font-family: 'Gretaros'; }
  .eastMiami .barlow { font-family: 'Barlow'; }
  .eastMiami #app { padding: 0; font-size: 16px; }
  .eastMiami a { color: unset; text-decoration: underline; }
  .eastMiami .container {  background: unset; border-radius: unset; text-align: left; }
  .eastMiami button { cursor: pointer; width: 100%; border: unset; padding: 10px; font-size: 18px; color: #fff; background: #545464 }
  .eastMiami input[type="text"] { width: 100%; border: 1px solid #545454; color: #545454; padding: 10px; font-size: 16px; }
  .eastMiami button:disabled { cursor: not-allowed; }
</style>